"use client";

import Image from "next/image";
import { motion, Variants } from "framer-motion";
import Link from "next/link";

const MotionLink = motion(Link);
interface ServiceLinkItem {
  id: number;
  category: string;
  title: string;
  subtitle: string;
  description: string;
  linkPath: string;
}

const SERVICE_LINKS: ServiceLinkItem[] = [
  {
    id: 1,
    category: "APP",
    title: "교통약자 이동정보, 위맵",
    subtitle: "Freedom to Move, For All",
    description: "이동약자들이 접근 가능한 공간과 길 정보를 제공합니다.",
    linkPath: "/app/pages/wemap",
  },
  {
    id: 2,
    category: "서비스",
    title: "입간판 경사로, 위슬로",
    subtitle: "Together, Without Barriers",
    description: "공간과 사람의 장벽을 낮추어 모두의 접근성을 높입니다.",
    linkPath: "/app/pages/weslo",
  },
  {
    id: 3,
    category: "APP",
    title: "저상버스 예약 APP, 위버스",
    subtitle: "Making Every Journey Accessible",
    description:
      "교통약자를 위한 저상버스 예약 및 운행 정보 서비스를 제공합니다.",
    linkPath: "/app/pages/webus",
  },
];
const listItemVariants: Variants = {
  hidden: { opacity: 0, y: 40 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } },
};

export function ServiceLinks() {
  return (
    <motion.div
      className="w-full xl:max-w-[1280px] mx-auto px-5 xl:px-0 flex flex-col space-y-20 md:space-y-32 my-20 md:my-40"
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.2 }}
    >
      <motion.div
        variants={{
          hidden: { opacity: 0, y: 20 },
          visible: { opacity: 1, y: 0, transition: { duration: 0.7 } },
        }}
        className="flex flex-col justify-center items-center"
      >
        <span
          className="md:text-2xl text-[15px] text-lightGray-20 mb-2 md:mb-6 tracking-tight"
          style={{ fontFamily: '"paperlogy-bold", sans-serif' }}
        >
          Door To Door
        </span>
        <p
          className="md:text-5xl text-xl text-black-almostBlack tracking-tight md:leading-18  leading-8"
          style={{ fontFamily: '"pre-SemiBold", sans-serif' }}
        >
          모두의 이동이 자유로울 때 까지
        </p>
      </motion.div>

      <motion.ul
        className="border-t md:border-t-[1.8px] border-midGray-30"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.2 }}
      >
        {SERVICE_LINKS.map((item) => (
          <motion.li
            key={item.id}
            variants={listItemVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.2 }}
            whileHover="hover" // 👈 hover 상태 이름 지정
            className="border-b md:border-b-[1.8px] border-midGray-30 py-7 md:py-10 px-2 transition-colors duration-300 hover:bg-gray-50"
          >
            <MotionLink
              href={item.linkPath}
              className="flex md:flex-row flex-col items-start md:items-center justify-between w-full"
            >
              <div className="flex mr-4 self-baseline">
                <span
                  className="text-2xl leading-11 max-screen-991:hidden w-52 text-lightGray-40 tracking-tight"
                  style={{ fontFamily: '"pre-SemiBold", sans-serif' }}
                >
                  {item.category}
                </span>
              </div>
              <div className=" flex grow flex-col flex-1 w-full ">
                <div className="flex justify-between items-center">
                  <div>
                    <p
                      className="md:text-3xl md:leading-12 text-lg leading-7  text-black-almostBlack  tracking-tight"
                      style={{ fontFamily: '"pre-SemiBold", sans-serif' }}
                    >
                      {item.title}
                    </p>
                    <p
                      className="md:text-lg md:leading-7 text-sm leading-5 tracking-tight text-softGray-70 mt-1 "
                      style={{ fontFamily: '"pre-Regular", sans-serif' }}
                    >
                      {item.subtitle}
                    </p>
                  </div>
                  <motion.div
                    variants={{
                      hover: { rotate: 45, scale: 1.1 },
                      rest: { rotate: 0, scale: 1 },
                    }}
                    transition={{ type: "spring", stiffness: 100, damping: 20 }}
                    className="w-4 h-4 mt-0 md:w-7 md:h-7 relative mr-2 md:mr-8"
                  >
                    <Image
                      src="/assets/images/icon/arrow-up-right.svg"
                      alt="LinkIcon"
                      fill
                      style={{ objectFit: "contain" }}
                    />
                  </motion.div>
                </div>
                <p
                  className="md:text-xl md:leading-8 text-lg leading-7 tracking-tight mt-4 md:mt-6 text-midGray-50"
                  style={{ fontFamily: '"pre-Medium", sans-serif' }}
                >
                  {item.description}
                </p>
              </div>
            </MotionLink>
          </motion.li>
        ))}
      </motion.ul>
    </motion.div>
  );
}
